'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = _interopDefault(require('react'));
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
var PropTypes = _interopDefault(require('prop-types'));
var getFont = functions.config.fonts.getFont;
var colors = functions.config.colors.list;
var OptionalWrapper = styled.span.withConfig({
  displayName: "OptionalText__OptionalWrapper",
  componentId: "sc-1wfqhyi-0"
})(["margin-left:.5rem;color:", ";font-family:", ";font-size:", ";line-height:", ";"], function (props) {
  return props.theme.dark ? colors.White : colors.GreyDark;
}, function (_ref) {
  var theme = _ref.theme;
  return getFont(theme, 'regular');
}, function (props) {
  return props.theme.type === 'secure' ? '1.2rem' : '1.4rem';
}, function (props) {
  return props.theme.type === 'secure' ? '1.6rem' : '1.8rem';
});
/* istanbul ignore next */

var OptionalSwitchLabel = function OptionalSwitchLabel(language) {
  switch (language) {
    case 'nl':
      return 'Optioneel';
    case 'fr':
      return 'Optionnel';
    case 'de':
      return 'Optional';
    default:
    case 'en':
      return 'Optional';
  }
};
var OptionalText = function OptionalText(props) {
  return /*#__PURE__*/React.createElement(OptionalWrapper, null, "(", OptionalSwitchLabel(props.language), ")");
};
OptionalText.defaultProps = {
  language: 'en'
};
exports.OptionalText = OptionalText;